import React, { useState } from 'react';
import {
  Drawer,
  MenuItem,
  IconButton,
  makeStyles
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MobileDrawer = ({
  anchor,
  navigationRoutes = [],
  icon,
  badgeInfo = {}
}) => {
  const { t } = useTranslation();
  const [ isOpen, setIsOpen ] = useState(false);

  const toggleDrawer = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setIsOpen(open);
  };

  const useStyles = makeStyles({
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gridGap: 8,
      fontSize: '13px'
    }
  }, { name: 'DrawerItem' });

  const classes = useStyles();

  return (
    <>
      <IconButton
        aria-label="account of current user"
        onClick={ toggleDrawer(true) }
        color="inherit"
      >
        {icon}
      </IconButton>
      <Drawer
        open={ isOpen }
        onClose={ toggleDrawer(false) }
        anchor={ anchor }
      >
        {navigationRoutes.map(route => (
          <MenuItem
            key={ route.path }
            component={ Link }
            to={ route.path }
            className={ classes.menuItem }
            onClick={ route.onClick }
          >
            <span>{ t(route.translationKey) }</span>
            <span>{ Number(badgeInfo[route.badgeInfoKey]) || '' }</span>
          </MenuItem>
        ))}
      </Drawer>
    </>
  );
};

export default MobileDrawer;